// Chip.js
import React from 'react';
import { mergeStyles } from '@fluentui/react';
import { Icon } from 'office-ui-fabric-react';

const Chip = ({ label, active, onRemove, counter, onClick }) => {
    // Using mergeStyles to define the chip container and button styles
    const chipClass = mergeStyles({
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        margin: '4px',
        borderRadius: '8px',
        backgroundColor: active ? 'black' : 'white',
        fontSize: '12px',
        color: active ? 'white' : 'black',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        border: 'black'
    });

    const deleteBtnClass = mergeStyles({
        marginLeft: '8px',
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        border: '1px solid white',
        color: '#ff3333',
        fontSize: '12px',
        cursor: 'pointer',
        padding: '0',
        zIndex: '99'
    });

    const customStyles = {
        root: {
            fontSize: 5, // Adjust the font size
            height: 12, // Adjust the height
            width: 12,
            color: 'white',
            background: 'black',
            transform: 'scale(1.5)',
            selectors: {
                '&:hover': {
                    color: 'black',
                    background: 'white',
                    transform: 'scale(1.5)',
                }, // Adjust the width
            },
        }
    };

    return (
        <div className={chipClass} onClick={onClick}>
            <span>{label + ' (' + counter + ')'}</span>
            &nbsp;
            {active &&
            <Icon className={deleteBtnClass} styles={customStyles} iconName="ChromeClose" onClick={onRemove}></Icon>}
        </div>
    );
};

export default Chip;
